import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PriceDisplayQuantityToggle from './PriceDisplayQuantityToggle';
import { translate } from '../Services/translation';
import ConsumerPriceModel from './ConsumerPriceModel';

const ProductPriceModel = (props) => {
  const {
    listPriceModel,
    consumerPriceModel,
    priceModel,
    simplifiedTierPriceModels: tierPrices,
    showPriceToggle = false,
    recyclingFee,
    onQuantityToggle,
  } = props;

  return (
    <div className="product__price">
      {priceModel && (
        <div className="product__price-wrapper">
          <span
            itemProp="offers"
            itemScope
            itemType="http://schema.org/Offer"
            className="product__price--price"
          >
            {tierPrices && tierPrices.length > 0
              ? tierPrices.map((tier, idx) => (
                  <div
                    key={'tierprice-' + idx}
                    className="product__price--tierprice"
                  >
                    {tier.tierPrice}
                  </div>
                ))
              : priceModel.price}
          </span>
          {listPriceModel?.listPrice && (
            <span className="product__price--list-price">
              {translate('product.listprice')} {listPriceModel.listPrice}{' '}
              {listPriceModel.listPriceDifference
                ? '(-' + listPriceModel.listPriceDifference + ')' + ' '
                : null}
            </span>
          )}
          {recyclingFee && (
            <span className="product__price--list-price product__price--recycling-fee">
              {translate('product.excluding-recycling-fee')} {recyclingFee}
            </span>
          )}
          <meta itemProp="price" content={priceModel.price} />
        </div>
      )}
      {consumerPriceModel && (
        <ConsumerPriceModel consumerPriceModel={consumerPriceModel} />
      )}
      {showPriceToggle && (
        <PriceDisplayQuantityToggle onToggle={onQuantityToggle} />
      )}
    </div>
  );
};

export default ProductPriceModel;
